import React, { Component } from 'react';

class PageBanner extends Component {
    state = {  }
    render() {
        // let title = this.props.page[0].toUpperCase() + this.props.page.slice(1)
        return (
            <div className="banner">
                <div className="banner-content max-view-width">
                    <h3>{this.props.page}</h3>
                </div>
                <div className="banner-footer"></div>
            </div>
        );
    }
}

export default PageBanner;